export const formatarDateTime = (data, separator='-') => {
    if (!data) return '--'

    const dataFormatada = new Date(data)
    const dia = dataFormatada.getDate()
    const mes = dataFormatada.getMonth() + 1
    const ano = dataFormatada.getFullYear()
    const hora = dataFormatada.getHours()
    const minuto = dataFormatada.getMinutes()
    return `${dia}/${mes}/${ano} ${separator} ${hora}h ${minuto}min`
}